import React, { FC, useEffect, useState } from "react";
import { TextField, InputAdornment, FilledInput } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import "./style.css"

interface ComponentProps {
    name: string
    inputRef?: any
    error?: any
    color?: 'primary' | 'secondary'
    variant?: 'filled' | 'outlined' | 'standard'
    placeholder?: string
    size?: 'medium' | 'small' | 'large'
    className?: string
    value?: any
    onChange?: any
    adornment?: any
    onAdornmentClick?: any
    onClear?: any
    type?: any
    autocomplete?: any
    style?: object
    dir?: "rtl" | "ltr"
}

const CustomInputNumber: FC<ComponentProps> = (
    { name, color = 'primary', variant = 'standard', inputRef, error, placeholder, size, className, onChange, value, adornment, onAdornmentClick, onClear, type = "text", autocomplete, style, dir }
) => {
    const [inputValue, setInputValue] = useState<string | undefined>(undefined)

    const validChar = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
    const validCharPersian = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']

    const handleInputChange = (props: any) => {
        const { target: { value, name } } = props

        let _value = value[value.length - 1]
        if (validChar?.indexOf(_value) >= 0) {
            setInputValue(value)
            onChange(props)
        } else {
            if (validCharPersian.indexOf(_value) >= 0) {
                const fixedValue = `${value.substr(0, value.length - 1)}${validChar[validCharPersian.indexOf(_value)]}`
                setInputValue(fixedValue)
                const event = {
                    target: {
                        value: fixedValue,
                        name: name
                    }
                }
                onChange(event)
            } else {
                setInputValue(value.substr(0, value.length - 1))
                const event = {
                    target: {
                        value: value.substr(0, value.length - 1),
                        name: name
                    }
                }
                onChange(event)
            }
        }
    }

    return (
      <TextField
        color={color}
        variant={variant}
        name={name}
        inputRef={inputRef}
        placeholder={placeholder}
        // @ts-ignore
        error={error && !!error[name]}
        // @ts-ignore
        helperText={error && error[name]?.message}
        type={type}
        autoComplete={"off"}
        value={value}
        onChange={handleInputChange}
        // @ts-ignore
        size={size}
        // @ts-ignore
        style={style}
        className={`input ${className} ${dir === "rtl" && "rtl"}`}
        startAdornment={
          adornment ? (
            <InputAdornment position="start" onClick={onAdornmentClick}>
              {adornment}
            </InputAdornment>
          ) : (
            onClear && (
              <CloseIcon
                style={{ color: "rgb(68 68 68)" }}
                onClick={() => onClear(name)}
              />
            )
          )
        }
      />
    );
}

export default CustomInputNumber
